module.exports = __webpack_public_path__ + "static/img/z6.0d6c918.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z6.png
// module id = 3in3
// module chunks = 0